<template>
  <div id="app">
    <transition
      appear
      name="router-anim"
      :enter-active-class="enterTransitionNames"
      :leave-active-class="leaveTransitionNames"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      validated: false,
      historyPages: [],
      commonClass: "animated ",
      enterTransitionNames: "animated fadeInDown",
      leaveTransitionNames: "animated fadeOutDown"
    };
  },
  watch: {
    $route(to, from) {
      // Default transitions
      let enterTrans = "slideInRight";
      let leaveTrans = "slideOutLeft";
      // Exceptions
      if (from.name == "public" && to.name == "public_player") {
        enterTrans = "fadeInUp";
        leaveTrans = "fadeOut";
        // Store lastPage
        this.historyPages.push(from.name);
      } else if (from.name == "public_player" && to.name == "public") {
        enterTrans = "fadeIn";
        leaveTrans = "fadeOutDown";
        // Remove lastPage
        this.historyPages.pop();
      }
      // Default back behavior
      else if (to.name == this.historyPages.slice(-1)) {
        enterTrans = "fadeIn";
        leaveTrans = "fadeOut";
        // Remove lastPage
        this.historyPages.pop();
      } else {
        // Store lastPage
        this.historyPages.push(from.name);
      }
      //console.log("History: " + this.historyPages.join("::"));
      // Set transitions
      this.enterTransitionNames = this.commonClass + enterTrans + " evenfaster";
      this.leaveTransitionNames = this.commonClass + leaveTrans + " evenfaster";
    }
  }
};
</script>
